var _defs, _rect, _path, _rect2, _rect3, _path2, _path3, _polygon, _polygon2, _polygon3, _path4, _path5, _line, _text, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _rect4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _g2, _path26, _path27, _path28, _path29, _path30, _g3, _g4, _path31, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _path32, _g5, _path33, _path34, _path35, _rect10, _path36, _circle, _g6, _path37, _path38, _path39, _path40, _path41, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogovisualelements6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-2,.cls-21,.cls-24,.cls-28,.cls-30,.cls-8{fill:none;}.cls-1,.cls-15{stroke:#2f2143;}.cls-1,.cls-15,.cls-21,.cls-24,.cls-28,.cls-30,.cls-8{stroke-miterlimit:10;}.cls-1{stroke-width:3.18px;}.cls-3{fill:#d8c4df;}.cls-4{fill:#af705c;}.cls-5{fill:#263238;}.cls-6{fill:#e6e6e6;}.cls-7{fill:#fdc435;}.cls-8{stroke:#263238;stroke-width:0.89px;}.cls-9{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-10,.cls-9{fill:#2f2143;}.cls-11{fill:#a34f40;}.cls-12{clip-path:url(#clip-path);}.cls-13{fill:#fff;}.cls-14{fill:#f04a49;}.cls-15{stroke-width:2.49px;}.cls-16{opacity:0.5;}.cls-17{clip-path:url(#clip-path-2);}.cls-18{fill:#9a499c;}.cls-19{fill:#f2d686;}.cls-20{fill:#2e1f42;}.cls-21{stroke:#4f4e4f;stroke-width:1.37px;}.cls-22{clip-path:url(#clip-path-3);}.cls-23{clip-path:url(#clip-path-4);}.cls-24{stroke:#2e1f42;stroke-width:1.95px;}.cls-25{fill:#e0e1e0;}.cls-26{clip-path:url(#clip-path-5);}.cls-27{fill:#293b4a;}.cls-28{stroke:#293b4a;}.cls-28,.cls-30{stroke-width:2px;}.cls-29{clip-path:url(#clip-path-6);}.cls-30{stroke:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 373.25,
    y: 88.29,
    width: 8,
    height: 7.12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1253.37,
    y: 201.1,
    width: 57.33,
    height: 64.94,
    transform: "translate(-20.79 262.17) rotate(-11.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1258.27,
    y: 209.04,
    width: 13.97,
    height: 13.12,
    transform: "translate(-17.52 258.43) rotate(-11.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1255.62,
    y: 207.15,
    width: 19.58,
    height: 18.39,
    transform: "translate(-17.67 258.48) rotate(-11.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1353.82,
    y: 45.76,
    width: 73.41,
    height: 73.29,
    transform: "translate(18.93 325.46) rotate(-13.44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 157.46,
    y: 127.95,
    width: 70.22,
    height: 70.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGO &amp;amp; VISUAL ELEMENTS 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1600,
    height: 326
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M455.43,177.8c1-4.28,2.74-6,3.46-6.6a18.78,18.78,0,0,1,2.61-1.94c1.12-.6,1.82-.74,2.34-1.5a4,4,0,0,0,.46-2.14,72.38,72.38,0,0,1,2.08-8.42c4.14-13.85,11.27-11.15,8.71-2.44-.93,3.15-.88,4.77-.52,5.87s.63,1.07,1.31,2.68a20.65,20.65,0,0,1,1.21,4.23c.47,3.23-.85,6.08-2,8.61a26.23,26.23,0,0,1-6,8.09,26.52,26.52,0,0,1-2.69,2.15Z",
    transform: "translate(0 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 477.46,
    y: 84.29,
    width: 2.84,
    height: 4.76,
    transform: "translate(97.6 389.1) rotate(-48.68)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 522.14,
    y: 121.57,
    width: 2.84,
    height: 4.76,
    transform: "translate(118.03 477.54) rotate(-54.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M542.85,97.12a1.86,1.86,0,1,1,1.4-2.22,1.85,1.85,0,0,1-1.4,2.22",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M484.39,65.5a1.76,1.76,0,1,1,1.33-2.1,1.77,1.77,0,0,1-1.33,2.1",
    transform: "translate(0 0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "500.87 146.13 480.62 156.54 459.31 140.14 464 116.79 514.59 83.84 510.34 102.54 500.87 146.13"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "474.83 164.25 452 147.05 458.51 138.72 481.33 155.92 474.83 164.25"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "505.43 96.2 506.96 97.55 481.34 133.03 479.8 131.68 505.43 96.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M485.43,134a4.72,4.72,0,1,1-.81-6.62h0a4.72,4.72,0,0,1,.8,6.61",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M479.35,86c10.61-9.83,27.13-11.39,38.07-3.51,12.34,8.88,15.74,27.11,6.59,40.81",
    transform: "translate(0 0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 484.13,
    y1: 63.85,
    x2: 542.21,
    y2: 95.34
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(692.04 160.12)"
  }, "LOGO &amp;", /*#__PURE__*/React.createElement("tspan", {
    x: -149.09,
    y: 75
  }, "VISUAL ELEMENTS"))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M413,151.9a26.07,26.07,0,0,1,3.67,12.89c.12,3.68,2.64,49.14,2.64,49.14L455,176.42l15.71,7.5s-33.33,47.71-47.5,53.26-24.38,3-27.6-1.29-6.74-62.11-6.74-62.11Z",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1539.81,254.09l-15.39-7.92,4.2-7a2.5,2.5,0,0,0-1.84-3.76L1484.26,230a2.51,2.51,0,0,0-2.42,3.84l23.79,36.77a2.5,2.5,0,0,0,4.25-.07l4.82-8.08,15,10.32a3,3,0,0,0,4.34-1.09l7-13.6a3,3,0,0,0-1.28-4",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M335.37,270.2c1.5-.59,16.2-6.06,27.14,1.43,2.23,1.53,4.24,3.6,13.23,32C379.87,316.71,379,326,379,326s-3.33.14-7.81,0c-2.6-.08-4.21.21-17.6,0-9.37-.15-26.19.61-38.38,0a5.11,5.11,0,0,1-2.65-.76c-4.61-3-2.17-14.3-1.34-18.11C313.4,296.94,317.71,277.06,335.37,270.2Z",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M317.42,256.79c12.7,7.3,17.24,19.47,14.25,30.52-3.54,13.07.46,38.6-13.13,38.68-31.43.18-19.37-.1-37.82.16-14,.2-26.18-.15-26.18-.15S269.1,293.29,277,274.39c8.22-19.72,38.15-18.95,40.45-17.6",
    transform: "translate(0 0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M450.13,153.55s22.2-15.33,25.71-15.82,4.83,16.25,2.23,23.75c-1.49,4.36-10.41,4.19-19.68,5.84Z",
    transform: "translate(0 0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M274.92,261.64c31.62,12.81,62.72,16.87,93,6.69,0,0,14.43-88.3,45.06-116.39a75.29,75.29,0,0,0-15.81-13,95.91,95.91,0,0,0-42-14.55,110.05,110.05,0,0,0-34.1,2.09s-42.1,48.91-46.11,135.2",
    transform: "translate(0 0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M323.57,125.94c14.43-2.44,41.1,71.29,53.49,72.79s73.07-45.18,73.07-45.18l8.26,13.77s-53,56.83-78.73,62.52-73.88-68.2-72.76-82.34,6.34-19.83,16.67-21.56",
    transform: "translate(0 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M358.43,126c-2.86,10.29,26.75,24.73,37.13,14.46-5.68-4.24-7.06-8.66-6.36-13a19.81,19.81,0,0,1,3.05-7.33,39.94,39.94,0,0,1,2.58-3.64l-12.6-26.08c-2.5,11.48-8.41,37.39-23.8,35.55",
    transform: "translate(0 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M425.37,68.16s3.79,17.7-7.16,26.79-13.58-31.3-13.58-31.3Z",
    transform: "translate(0 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377,81.11c-.06,15.84-.42,24.76,7.24,33.38,11.54,13,31.58,7.32,36.52-8.19,4.44-14,3.8-37.51-11.69-44.78-15.26-7.17-32,3.75-32.07,19.59",
    transform: "translate(0 0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M377.25,62c2.81-8.53,25.21-7,31.16-2.11.9.73-12.8,6.25-12,6l-6.38,1.65c-.95-.28-2.91.68-4.09,3.52,0,0-.91,24.22-8.42,30.71-5.48-3.09-5.17-12.7-6.57-18.53-2.09-8.69-4.46-21.37,6.28-21.26",
    transform: "translate(0 0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M398.06,85.54c-.11,1.61.69,3,1.77,3s2.06-1.19,2.17-2.8-.69-3-1.78-3.05-2.05,1.19-2.16,2.8",
    transform: "translate(0 0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M414.3,88.73c-.11,1.61.68,3,1.77,3s2.05-1.18,2.16-2.79-.68-3-1.77-3-2,1.19-2.16,2.8",
    transform: "translate(0 0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M409.59,88.11c1.24,2,2.34,4,3.42,6.08s2.35,4,3.57,6l.55.88-1-.18q-1.72-.33-3.45-.72t-3.42-.87c1.18.06,2.35.15,3.52.27s2.34.26,3.5.43l-.45.69a49,49,0,0,1-3.61-6c-.51-1.06-1-2.15-1.39-3.23S410,89.21,409.59,88.11Z",
    transform: "translate(0 0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M396.35,79.44a.81.81,0,0,0,.78,0,6.39,6.39,0,0,1,5.58-.82.79.79,0,0,0,1-.41.73.73,0,0,0-.42-1,7.94,7.94,0,0,0-7.05,1,.73.73,0,0,0-.21,1,.75.75,0,0,0,.3.26",
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.71,89.7a3,3,0,0,1,3.18-.79,5.12,5.12,0,0,1,2.64,2.17A7.93,7.93,0,0,1,380.79,95",
    transform: "translate(0 0)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 373.25,
    y: 88.29,
    width: 8,
    height: 7.12
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M423.78,82.53a.77.77,0,0,0,.4-.18.74.74,0,0,0,.07-1.07,7.85,7.85,0,0,0-6.55-2.64.77.77,0,0,0-.66.86.78.78,0,0,0,.88.64,6.11,6.11,0,0,1,5.17,2.14.79.79,0,0,0,.69.25",
    transform: "translate(0 0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M373.86,95.61c-2.73-13.9-.28-28.77,3.32-32.87s21.67,6.46,21.67,6.46c-4.23-1.11-8.47,2.43-7.11,6.67,1.9,5.91-1.89,14.7-6.55,18,0,0,0-2.5-2.14-2s-3.82,13.35-.05,19.81c0,0-6.39-2.17-9.14-16.06",
    transform: "translate(0 0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M372.69,92.87a14.84,14.84,0,0,0,7.69,8.35c4.73,2.18,7.91-1.89,7.29-6.78-.61-4.36-3.79-10.86-8.85-10.92s-7.75,4.78-6.13,9.35",
    transform: "translate(0 0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M425.11,68.16s-4.81,5.68-18.81,4.28a38.27,38.27,0,0,0,9.47-2S397,73,388,69.64s-11.14-6.9-11.14-6.9,1.54-9.47,22.28-8.27,27.34,10.17,25.93,13.69",
    transform: "translate(0 0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M407.54,106.21a45,45,0,0,0-4.64,4.62c-.32-.2-.66-.4-1-.61-4.42-2.8-5.56-5.55-5.45-7.76a6.86,6.86,0,0,1,.95-3,6,6,0,0,1,1.1-1.45c1.46,2.88,5.36,5.79,7.52,7.26,1,.6,1.49,1,1.49,1",
    transform: "translate(0 0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M406.12,105.21l-1.41,1.32c-4.14-2.63-6.71-5-7.22-7.14a6.76,6.76,0,0,1,1.1-1.45c1.47,2.91,5.37,5.8,7.53,7.27",
    transform: "translate(0 0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M402,110.2c-4.42-2.79-5.56-5.55-5.45-7.75a17,17,0,0,1,4.3,4.06A6.4,6.4,0,0,1,402,110.2",
    transform: "translate(0 0)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 683.45,
    y: 98.06,
    width: 223.61,
    height: 70.34
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 679.85,
    y: 92.78,
    width: 7.2,
    height: 8.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 679.55,
    y: 165.16,
    width: 7.04,
    height: 8.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 793.39,
    y: 94.2,
    width: 6.54,
    height: 7.71
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 792.55,
    y: 164.43,
    width: 6.72,
    height: 7.93
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 903.71,
    y: 94.1,
    width: 6.71,
    height: 7.92
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 903.71,
    y: 164.44,
    width: 6.71,
    height: 7.92
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1309.34,224.09c.56,2.56,2.16,9.85-1.38,16.23-1.94,3.47-4.33,4.76-6.09,9.56s-.24,6.16-1.77,9c-3.57,6.58-17.2,9.06-23.58,4-2.52-2-2-3.7-5.9-7.11-3.6-3.2-6.08-3.53-8.86-5.39-6.42-4.29-8.11-12.48-8.57-14.74-2.51-12.14,5.13-30.31,22.32-33.84s31.21,10.34,33.83,22.33",
    transform: "translate(0 0)"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1309.34,224.09c.56,2.56,2.16,9.85-1.38,16.23-1.94,3.47-4.33,4.76-6.09,9.56s-.24,6.16-1.77,9c-3.57,6.58-17.2,9.06-23.58,4-2.52-2-2-3.7-5.9-7.11-3.6-3.2-6.08-3.53-8.86-5.39-6.42-4.29-8.11-12.48-8.57-14.74-2.51-12.14,5.13-30.31,22.32-33.84s31.21,10.34,33.83,22.33",
    transform: "translate(0 0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1299.32,263.17l-20.13,4.13a3.81,3.81,0,1,1-1.53-7.46l20.13-4.13a3.81,3.81,0,1,1,1.53,7.46",
    transform: "translate(0 0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1302.07,273.13l-20.43,4.18a3.65,3.65,0,1,1-1.47-7.16L1300.6,266a3.66,3.66,0,0,1,1.47,7.17",
    transform: "translate(0 0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1303.66,283.63l-19.35,4a4.21,4.21,0,1,1-1.69-8.25l19.35-4a4.21,4.21,0,0,1,1.69,8.25",
    transform: "translate(0 0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1283.65,258.61s-1.39-14.78-4.56-18.69-4.86,4.6-1.49,4.32,5.6-2.61,6.76-5.58-3.94-5.95-2.55-1.49,7,3,8.79,2.77-1.31-8.14-2.55-4.41.65,5,2.07,7.43,3.17,13.67,3.17,13.67",
    transform: "translate(0 0)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1270.25,209c2.13,1.6,1.62,5.86-1.14,9.51s-6.71,5.3-8.84,3.69-1.62-5.86,1.13-9.51,6.72-5.3,8.85-3.69",
    transform: "translate(0 0)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1272.4,207.09c3,2.26,2.28,8.23-1.58,13.34s-9.41,7.43-12.4,5.18-2.27-8.23,1.59-13.34,9.41-7.43,12.39-5.18",
    transform: "translate(0 0)"
  })))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1301.71,293.53l-10.39,2.12a4.53,4.53,0,0,1-5.35-3.53l-.41-2a4.55,4.55,0,0,1,3.53-5.35l10.39-2.13a4.55,4.55,0,0,1,5.35,3.53l.41,2a4.56,4.56,0,0,1-3.53,5.36",
    transform: "translate(0 0)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1300.74,
    y1: 196.73,
    x2: 1310.02,
    y2: 186.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1279.25,
    y1: 196.19,
    x2: 1276.49,
    y2: 182.73
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1261.51,
    y1: 201.85,
    x2: 1252.86,
    y2: 191.18
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1250.39,
    y1: 215.93,
    x2: 1237.36,
    y2: 211.59
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1248.13,
    y1: 232.24,
    x2: 1234.68,
    y2: 235
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1252.64,
    y1: 247.31,
    x2: 1242.01,
    y2: 256.01
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1310,
    y1: 213.26,
    x2: 1323.55,
    y2: 211.01
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 1315.61,
    y1: 231.07,
    x2: 1328.98,
    y2: 234.22
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M70.84,62.06a19.44,19.44,0,0,0-2.75,6.66l-3.71.35v7.19l3.71.35a19.36,19.36,0,0,0,2.75,6.66l-2.38,2.86,5.09,5.09,2.87-2.37a19.39,19.39,0,0,0,6.65,2.75l.35,3.71h7.2L91,91.6a19.39,19.39,0,0,0,6.65-2.75l2.87,2.37,5.09-5.09-2.37-2.86A19.14,19.14,0,0,0,106,76.61l3.72-.35V69.07L106,68.72a19.05,19.05,0,0,0-2.75-6.66l2.38-2.86-5.09-5.09-2.87,2.37A19.17,19.17,0,0,0,91,53.74L90.62,50h-7.2l-.35,3.72a19.17,19.17,0,0,0-6.65,2.74l-2.87-2.37L68.46,59.2Zm23.07,3.72a9.74,9.74,0,1,1-13.78,0,9.74,9.74,0,0,1,13.78,0",
    transform: "translate(0 0)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1429.72,110.71l-61.37,14.67a5.16,5.16,0,0,1-6.21-3.82L1347.5,60.31a5.16,5.16,0,0,1,3.82-6.21l61.37-14.67a5.16,5.16,0,0,1,6.21,3.82l14.64,61.25a5.16,5.16,0,0,1-3.82,6.21",
    transform: "translate(0 0)"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1411.41,44.55a1.93,1.93,0,1,1-2.32-1.43,1.93,1.93,0,0,1,2.32,1.43",
    transform: "translate(0 0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1406.07,45.75a1.93,1.93,0,1,1-2.33-1.43,1.95,1.95,0,0,1,2.33,1.43",
    transform: "translate(0 0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1400.74,47a1.93,1.93,0,1,1-2.33-1.43,1.93,1.93,0,0,1,2.33,1.43",
    transform: "translate(0 0)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1372.61,
    y: 67.08,
    width: 36.8,
    height: 36.8,
    transform: "translate(18.23 325.66) rotate(-13.44)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1395.64,103.84s14.63-19.71,14.69-19.44l3.6,15.07Z",
    transform: "translate(0 0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 71.55,
    cy: 275.73,
    r: 15.47
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M224,198.05h-62.9a3.66,3.66,0,0,1-3.66-3.66V131.61a3.66,3.66,0,0,1,3.66-3.66H224a3.66,3.66,0,0,1,3.66,3.66v62.78a3.66,3.66,0,0,1-3.66,3.66",
    transform: "translate(0 0)"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M227.68,136.66H157.46v-5.28a3.42,3.42,0,0,1,3.43-3.43h63.42a3.37,3.37,0,0,1,3.37,3.37Z",
    transform: "translate(0 0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M220.42,132.43a1.85,1.85,0,1,1-1.84-1.85,1.84,1.84,0,0,1,1.84,1.85",
    transform: "translate(0 0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M215.18,132.35a1.85,1.85,0,1,1-1.84-1.84,1.85,1.85,0,0,1,1.84,1.84",
    transform: "translate(0 0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M209.94,132.35a1.85,1.85,0,1,1-1.85-1.84,1.85,1.85,0,0,1,1.85,1.84",
    transform: "translate(0 0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M210.63,147.4v10.25h-1a16.31,16.31,0,0,0-2-5.1,7.56,7.56,0,0,0-3-2.47,9.46,9.46,0,0,0-3.71-.5h-2.83v29.23a12.1,12.1,0,0,0,.32,3.63,3,3,0,0,0,1.26,1.27,5.15,5.15,0,0,0,2.56.55h1.26v1H183.67v-1h1.25a5.27,5.27,0,0,0,2.66-.59,2.69,2.69,0,0,0,1.14-1.34,11.32,11.32,0,0,0,.31-3.52V149.58h-2.74q-3.82,0-5.56,1.62a10.73,10.73,0,0,0-3.07,6.45H176.6V147.4Z",
    transform: "translate(0 0)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 1106.96,
    cy: 96.28,
    r: 15.39
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogovisualelements6);
export default __webpack_public_path__ + "static/media/LOGO & VISUAL ELEMENTS 6.75e5064830a82939178240e5098662aa.svg";
export { ForwardRef as ReactComponent };